import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_WEBSOCKET_URL, {
  reconnectionDelayMax: 1000,
  //secure: true,
  //transports: ['websocket', 'polling'],
});

export default socket;
